export const isTestEnv = import.meta.env.VITE_ENV_NAME === 'TEST'
export const isStagingEnv = import.meta.env.VITE_ENV_NAME === 'STAGING'
export const isProductionEnv = import.meta.env.VITE_ENV_NAME === 'PROD'
